import React, { useState } from "react";

import { Button, CircularProgress, Menu } from "@material-ui/core";

import { useListContext, useNotify } from "react-admin";

import { ExportMenuItem } from "./ExportButton";
import { ExportIcon } from "./iconography";

const ExportDropDown = ({
  total,
  resource,
  exporter,
  exporterPdf,
  perPage,
}) => {
  const { filterValues } = useListContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const open = Boolean(anchorEl);

  let gteValue = null;
  let lteValue = null;

  if (Array.isArray(filterValues.and)) {
    filterValues.and.forEach((filter) => {
      const key = Object.keys(filter)[0];
      if (filter[key]?.gte) {
        gteValue = filter[key].gte;
      }
      if (filter[key]?.lte) {
        lteValue = filter[key].lte;
      }
    });
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportCsv = (data) => {
    exporter(data);
  };

  const handleExportPdf = async (data, _1, _2, _3, filter) => {
    await exporterPdf(data, gteValue, lteValue, notify, filter);
  };

  return (
    <>
      <Button
        id="export-button"
        aria-controls={open ? "export-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={loading ? () => {} : handleClick}
        color="primary"
        size="small"
        startIcon={
          loading ? (
            <CircularProgress color="inherit" size={17} />
          ) : (
            <ExportIcon />
          )
        }
      >
        Export
      </Button>

      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        getContentAnchorEl={null}
      >
        <ExportMenuItem
          label={"CSV"}
          disabled={total === 0 || loading}
          resource={resource}
          exporter={handleExportCsv}
          onClick={() => handleClose()}
          onLoadingChange={(isLoading) => setLoading(isLoading)}
        />

        <ExportMenuItem
          label={"PDF"}
          disabled={total === 0 || loading}
          resource={resource}
          exporter={handleExportPdf}
          onClick={() => handleClose()}
          onLoadingChange={(isLoading) => setLoading(isLoading)}
        />
      </Menu>
    </>
  );
};

export default ExportDropDown;
